import * as React from 'react';

import {
    zIndexOrder,
} from "../Interface";

export const drawPlanArea = (
    planArea: any,
    map: google.maps.Map,
) => {
    planArea.forEach((data: any, index: any) => {
        try {
            if (data.step >= 8) {
                return;
            }

            let iconUrl: string = ""
            let existingFeature: boolean = false
            if (Number(data.step) === 0) {
                // STEP0：黒
                iconUrl = process.env.PUBLIC_URL + '/image/icons/double_circle_black.svg'
            } else if (Number(data.step) === 7) {
                // STEP7：透けてるSEJアイコン
                iconUrl = process.env.PUBLIC_URL + '/image/icons/sej_cleanness.png'
            } else if (data.zone_id) {
                if (!data.zone_is_partial_step) {
                    // 同じZONE内にSTEP4以上の候補地が存在しない（is_partial_step=false）
                    iconUrl = process.env.PUBLIC_URL + '/image/icons/double_circle_blue.svg'
                } else if (Number(data.step) >= 4) {
                    // 同じZONE内にSTEP4以上の候補地が存在する（is_partial_step=true）
                    // STEP4以上：赤
                    iconUrl = process.env.PUBLIC_URL + '/image/icons/double_circle.svg'
                    existingFeature = true
                } else {
                    // 同じZONE内にSTEP4以上の候補地が存在する（is_partial_step=true）
                    // STEP3以下：グレー
                    iconUrl = process.env.PUBLIC_URL + '/image/icons/double_circle_gray.svg'
                }
            } else {
                // ZONEに入っていない（zone_idが空）
                // →STEP1～6：青
                iconUrl = process.env.PUBLIC_URL + '/image/icons/double_circle_blue.svg'
            }

            // AdvancedMarkerElement用のHTMLImageElementを作成
            const img = document.createElement('img');
            img.src = iconUrl;
            img.style.width = 'auto';
            img.style.height = 'auto';
            img.style.position = 'absolute';
            img.style.left = '-15px';
            img.style.top = '-15px';

            var marker = new google.maps.marker.AdvancedMarkerElement({
                position: {
                    lat: data.centerlat,
                    lng: data.centerlon,
                },
                content: img,
                zIndex: zIndexOrder.kouhochiPolygon,
            });
            marker.map = map;

        } catch (error) {
            console.log("------------------------")
            console.log("表示エラー")
            console.log(error)
            console.log(data)
            console.log("------------------------")
        }
    })
    return planArea;
}

export interface planAreaProps {
    props:{
    }
  }

const PlanArea:React.FC<planAreaProps> = ({props}) => {

    return (
        <></>
    );
        
}


export default PlanArea;
